import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Button,
  SearchSelect,
  SearchSelectItem,
  Select,
  SelectItem,
  TextInput,
} from "@tremor/react";
import {
  RegisterDriverModal,
  RegisterStatusModal,
  TitlePageInfo,
} from "../components";
import { getUsersApp, getDrivers } from "../../store/admin/";
// import { useForm } from "../../hooks";
import { adminAPI } from "../../api/adminAPI";
import { AlertBox } from "../../ui";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";

export const FormServicesAdminLayout = ({
  isEditMode = false,
  dataToEdit = {},
}) => {
  const navigate = useNavigate();
  const { appUsers, drivers } = useSelector((state) => state.admin);
  const { jwt } = useSelector((state) => state.auth);
  const [clients, setClients] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [status, setStatus] = useState([]);
  const [showModal, setModal] = useState(false);
  const [showModalStatus, setModalStatus] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
  } = useForm();

  // const {
  //   clientID,
  //   buyerID,
  //   invoiceNumber,
  //   travelNumber,
  //   economicCode,
  //   feet,
  //   driverID,
  //   phone,
  //   CAAT,
  //   integrationNumber,
  //   plateNumber,
  //   statusID,
  //   alphaCode,
  //   onInputChange,
  //   isFormValid,
  //   formState,
  // } = useForm({
  //   clientID: isEditMode ? dataToEdit.clientID : 0,
  //   buyerID: isEditMode ? dataToEdit.buyerID : 0,
  //   invoiceNumber: isEditMode ? dataToEdit.invoiceNumber : "",
  //   travelNumber: isEditMode ? dataToEdit.travelNumber : "",
  //   economicCode: isEditMode ? dataToEdit.economicCode : "",
  //   feet: isEditMode ? dataToEdit.feet : "",
  //   driverID: isEditMode ? dataToEdit.driverID : null,
  //   phone: isEditMode ? dataToEdit.phone : "",
  //   CAAT: isEditMode ? dataToEdit.CAAT : "",
  //   integrationNumber: isEditMode ? dataToEdit.integrationNumber : "",
  //   plateNumber: isEditMode ? `${dataToEdit.plateNumber}` : "",
  //   statusID: isEditMode ? dataToEdit.status : null,
  //   alphaCode: isEditMode ? dataToEdit.alphaCode : "",
  // });

  const getStatus = async () => {
    const resp = await adminAPI
      .get("/status")
      .catch(({ response }) => response);
    if (resp.status !== 200) {
      const { data } = resp.data;
      const errors = data.message
        ? [data.message]
        : data.errors.map((err) => err.msg);
      AlertBox({ color: "warning", messages: errors });
      return;
    }
    const { data } = resp.data;
    setStatus(data);
  };

  useEffect(() => {
    const buyersUsers = appUsers.filter((data) => data.isBuyer === true);
    const clientsUsers = appUsers.filter((data) => data.isBuyer === false);
    setClients(clientsUsers);
    setBuyers(buyersUsers);
  }, [appUsers]);

  useEffect(() => {
    getStatus();
    dispatch(getDrivers());
    dispatch(getUsersApp());
  }, [dispatch]);

  const onSubmit = async (formValues) => {
    const formData = {
      ...formValues,
    };

    const headers = {
      "x-token": jwt,
    };

    const resp = await adminAPI
      .post("/services", formData, { headers })
      .catch(({ response }) => response);

    const { data } = resp.data;
    if (resp.status !== 200) {
      const errors = data.message
        ? [data.message]
        : data.errors.map((err) => err.msg);
      AlertBox({ color: "warning", messages: errors });
      return;
    }
    AlertBox({ color: "success", messages: ["Servicio creado correctamente"] });

    if (resp.data.cleanupTriggered) {
      setTimeout(() => {
        AlertBox({
          color: "info",
          messages: [
            "Mantenimiento automático: Estamos liberando espacio de chats muy antiguos en segundo plano. Puedes continuar trabajando sin problemas."
          ],
        });
      }, 1500);
    }

    navigate("/admin/services");
  };

  const showModalDriver = () => {
    setModal(!showModal);
  };

  const isShowModalStatus = () => {
    setModalStatus(!showModalStatus);
  };

  const dismissModalDriver = () => {
    setModal(false);
  };

  const dismissModalStatus = () => {
    setModalStatus(false);
  };

  return (
    <>
      {showModal ? (
        <RegisterDriverModal cancelFunction={dismissModalDriver} />
      ) : (
        <></>
      )}
      {showModalStatus ? (
        <RegisterStatusModal
          cancelFunction={dismissModalStatus}
          getStatus={getStatus}
        />
      ) : (
        <></>
      )}
      <TitlePageInfo title="Alta de Nuevo Servicio" />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <p>Cliente</p>
          <Controller
            name="clientID"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Seleccione un cliente",
              },
            }}
            render={({ field }) => (
              <SearchSelect {...field}>
                {clients.map((client) => (
                  <SearchSelectItem key={client.id} value={client.id}>
                    {client.name} - {client.email}
                  </SearchSelectItem>
                ))}
              </SearchSelect>
            )}
          />
          {errors.clientID && (
            <p className="text-red-500 text-xs italic">
              {errors.clientID.message}
            </p>
          )}
        </div>

        <div>
          <p>Comprador</p>
          <Controller
            name="buyerID"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Seleccione un comprador",
              },
            }}
            render={({ field }) => (
              <SearchSelect {...field}>
                {buyers.map((client) => (
                  <SearchSelectItem key={client.id} value={client.id}>
                    {client.name} - {client.email}
                  </SearchSelectItem>
                ))}
              </SearchSelect>
            )}
          />
          {errors.buyerID && (
            <p className="text-red-500 text-xs italic">
              {errors.buyerID.message}
            </p>
          )}
        </div>
        <div className="grid grid-cols-4 gap-2">
          <div>
            <p>Factura</p>
            <TextInput
              placeholder="Numero de Factura"
              name="invoiceNumber"
              {...register("invoiceNumber", {
                required: {
                  value: true,
                  message: "Numero de Factura es requerido",
                },
                minLength: {
                  value: 4,
                  message: "Numero de Factura debe tener al menos 4 caracteres",
                },
              })}
            />
            {errors.invoiceNumber && (
              <p className="text-red-500 text-xs italic">
                {errors.invoiceNumber.message}
              </p>
            )}
          </div>
          <div>
            <p>Número de Viaje</p>
            <TextInput
              placeholder="1234-ABC"
              name="travelNumber"
              {...register("travelNumber", {
                required: {
                  value: true,
                  message: "Numero de Viaje es requerido",
                },
                minLength: {
                  value: 4,
                  message: "Numero de Viaje debe tener al menos 4 caracteres",
                },
              })}
            />
            {errors.travelNumber && (
              <p className="text-red-500 text-xs italic">
                {errors.travelNumber.message}
              </p>
            )}
          </div>
          <div>
            <p>Número Económico</p>
            <TextInput
              placeholder="ABC-1234"
              name="economicCode"
              {...register("economicCode", {
                required: {
                  value: true,
                  message: "Numero Económico es requerido",
                },
                minLength: {
                  value: 1,
                  message: "Numero Económico debe tener al menos 1 caracteres",
                },
              })}
            />
            {errors.economicCode && (
              <p className="text-red-500 text-xs italic">
                {errors.economicCode.message}
              </p>
            )}
          </div>
          <div>
            <p>Pies</p>
            <TextInput
              placeholder="3,4 ft"
              name="feet"
              {...register("feet", {
                required: {
                  value: true,
                  message: "Pies es requerido",
                },
              })}
            />
            {errors.feet && (
              <p className="text-red-500 text-xs italic">
                {errors.feet.message}
              </p>
            )}
          </div>
          <div>
            <p>Conductor</p>
            <Controller
              name="driverID"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Seleccione un conductor",
                },
              }}
              render={({ field }) => (
                <SearchSelect placeholder="Seleccionar..." {...field}>
                  <SearchSelectItem onClick={showModalDriver}>
                    <p className="font-extrabold">Registrar Nuevo Conductor</p>
                  </SearchSelectItem>
                  {drivers.map((d) => (
                    <SearchSelectItem key={d.id} value={d.id}>
                      {d.name}
                    </SearchSelectItem>
                  ))}
                </SearchSelect>
              )}
            />
            {errors.driverID && (
              <p className="text-red-500 text-xs italic">
                {errors.driverID.message}
              </p>
            )}
          </div>
          <div className="col-span-2">
            <p>Celular</p>
            <TextInput
              placeholder="81 0000 0000"
              name="phone"
              {...register("phone", {
                required: {
                  value: true,
                  message: "Celular es requerido",
                },
                minLength: {
                  value: 10,
                  message: "Celular debe tener al menos 10 caracteres",
                },
              })}
            />
            {errors.phone && (
              <p className="text-red-500 text-xs italic">
                {errors.phone.message}
              </p>
            )}
          </div>
          <div>
            <p>CAAT</p>
            <TextInput
              name="CAAT"
              {...register("CAAT", {
                required: {
                  value: true,
                  message: "CAAT es requerido",
                },
                minLength: {
                  value: 4,
                  message: "CAAT debe tener al menos 4 caracteres",
                },
              })}
            />
            {errors.CAAT && (
              <p className="text-red-500 text-xs italic">
                {errors.CAAT.message}
              </p>
            )}
          </div>
          <div>
            <p>No. Integración</p>
            <TextInput
              placeholder="1234"
              name="integrationNumber"
              {...register("integrationNumber", {
                required: {
                  value: false,
                  message: "No. Integración es requerido",
                },
              })}
            />
            {errors.integrationNumber && (
              <p className="text-red-500 text-xs italic">
                {errors.integrationNumber.message}
              </p>
            )}
          </div>
          <div className="col-span-3">
            <p>No. Placa</p>
            <TextInput
              placeholder="1234"
              className="w-1/3"
              name="plateNumber"
              {...register("plateNumber", {
                required: {
                  value: true,
                  message: "Placa es requerido",
                },
                minLength: {
                  value: 4,
                  message: "Placa debe tener al menos 4 caracteres",
                },
              })}
            />
            {errors.plateNumber && (
              <p className="text-red-500 text-xs italic">
                {errors.plateNumber.message}
              </p>
            )}
          </div>
          <div>
            <p>Estatus</p>
            <Controller
              name="statusID"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Seleccione un estatus",
                },
              }}
              render={({ field }) => (
                <SearchSelect placeholder="Seleccionar..." {...field}>
                  <SearchSelectItem onClick={isShowModalStatus}>
                    <p className="font-extrabold">Registrar Nuevo Estatus</p>
                  </SearchSelectItem>
                  {status.map((s) => (
                    <SearchSelectItem key={s.id} value={s.id}>
                      {s.name}
                    </SearchSelectItem>
                  ))}
                </SearchSelect>
              )}
            />
            {errors.statusID && (
              <p className="text-red-500 text-xs italic">
                {errors.statusID.message}
              </p>
            )}
          </div>
          <div>
            <p>Codigo Alfa</p>
            <TextInput
              placeholder="1234-ABCD"
              name="alphaCode"
              {...register("alphaCode", {
                required: {
                  value: true,
                  message: "Codigo Alfa es requerido",
                },
                minLength: {
                  value: 4,
                  message: "Codigo Alfa debe tener al menos 4 caracteres",
                },
              })}
            />
            {errors.alphaCode && (
              <p className="text-red-500 text-xs italic">
                {errors.alphaCode.message}
              </p>
            )}
          </div>
          <div>
            <p>Número de Pedimento</p>
            <TextInput
              placeholder="Pedimento..."
              name="requirementNumber"
              {...register("requirementNumber")}
            />
          </div>
          <div>
            <p>Remesas</p>
            <TextInput
              placeholder="Remesas..."
              name="remesas"
              {...register("remesas")}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Guardando..." : "Guardar"}
          </Button>
        </div>
      </form>
    </>
  );
};

FormServicesAdminLayout.propTypes = {
  isEditMode: PropTypes.bool,
  dataToEdit: PropTypes.object,
};
